module.exports = __webpack_public_path__ + "img/logo.ce09c69e.png";